import { UnreadCountsEnum } from '../models/UnreadCountsEnum'
import { UnreadCountRepository } from '../repositories/UnreadCountRepository'

export function ReduceUnreadCountCase(
  unreadCountRepository: UnreadCountRepository
) {
  return function (params: {
    profileId: string
    countPath: UnreadCountsEnum
    reduceBy?: number
  }) {
    return unreadCountRepository.reduceUnreadCount(params)
  }
}
